module.exports = () => {
  return {
    filtering: {
      value: {},
      children: {
        name: {
          type: 'input',
          props: {
            placeholder: '请输入转化名称',
          },
          value: '',
        },
      },
    },
  };
};
